import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import classes from '../../../_common/Tables/styles.module.scss';
import Pagination from '../../../_common/Pagination/Pagination';
import Loader from '../../../_common/Loader/Loader';
import accountHelpers from '../../../../utils/accountHelpers';

const scriptStatusLocation = ['Review', 'Prior Auth', 'Process', 'Copay Assistance', 'Schedule'];
const scriptStatusShipOn = ['QA', 'Fill', 'Shipped', 'Done'];

const renderOtherSection = (script) => {
  if (scriptStatusLocation.includes(script.status)) {
    return <div>{script.location ? script.location : '-'}</div>;
  }

  if (scriptStatusShipOn.includes(script.status)) {
    return <div>{script.shipOn ? moment(script.shipOn).format('MM.DD.YYYY') : '-'}</div>;
  }

  return <div>-</div>;
};

const ScriptTable = ({
  data, header, className, page, limit, totalPage, onChange,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const trClass = [classes.tr];

  if (className) trClass.push(className);

  const onChangeLoading = async (path, count) => {
    setLoading(true);
    await onChange(path, count);
    setLoading(false);
  };

  return (
    !data.length && !loading
      ? <div className={classes.notResult}>No Data Found</div>

      : (
        <div className={classes.script_loader_wrapper}>
          { loading && <Loader className={classes.loader_wrapper} />}

          <div className={classes.table_wrapper}>
            <div className={classes.table__border}>
              <table className={classes.table}>

                <thead className={classes.thead}>
                  <tr className={classes.tr}>
                    {header.map((h) => (
                      <th className={classes.th} key={h}>{h}</th>
                    ))}
                  </tr>
                </thead>

                <tbody className={classes.tbody}>
                  {data.map((d) => (
                    <tr className={trClass.join(' ')} key={d.id} onClick={() => navigate(`/scripts/${d.id}`)}>

                      <td className={classes.td}>{d.status}</td>

                      <td className={classes.td}>{moment(d.processedOn).format('MM/DD/YYYY')}</td>

                      <td className={classes.td}>{moment(d.updatedAt).fromNow()}</td>

                      <td className={classes.td}>{d.notesUpdated ? moment(d.notesUpdated).fromNow() : <p />}</td>

                      {+accountHelpers.getUser().id !== 601 && (
                        <td className={classes.td}>
                          {d.Physician ? `${d.Physician.firstName} ${d.Physician.lastName}` : null}
                        </td>
                      )}

                      {+accountHelpers.getUser().id !== 601 && (
                        <td className={classes.td}>
                          {d.Patient ? `${d.Patient.firstName} ${d.Patient.lastName}` : null}
                        </td>
                      )}

                      <td className={classes.td}>
                        {d.Product ? d.Product.name : null}
                      </td>

                      <td className={classes.td}>{renderOtherSection(d)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <Pagination page={page} limit={limit} totalPage={totalPage} onChange={onChangeLoading} />
        </div>
      )
  );
};

ScriptTable.propTypes = {
  header: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  totalPage: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
};

ScriptTable.defaultProps = {
  className: '',
};

export default ScriptTable;
